module.exports = __webpack_public_path__ + "static/media/enhanced-instore-experience-icon_2-color.6d32625a.svg";